module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isInit) ? _c('text', {
    staticClass: ["icon-font"],
    style: _vm.mergeStyle,
    on: {
      "click": _vm.itemClicked
    }
  }, [_vm._v(_vm._s(_vm.code))]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-62aa8be1!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-iconfont/index.vue
// module id = 632
// module chunks = 0 1